import { render, staticRenderFns } from "./StockHeader.vue?vue&type=template&id=15810263&"
import script from "./StockHeader.vue?vue&type=script&lang=ts&"
export * from "./StockHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StockHeader.vue?vue&type=style&index=0&id=15810263&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports